import React from 'react';
import useTranslation from '../hooks/useTranslation';
import './Footer.css';

const Footer = () => {
  const { t, isRTL } = useTranslation();
  const year = new Date().getFullYear();
 
  const socialLinks = [
    { name: 'Instagram', url: 'https://instagram.com/orkina', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' },
    { name: 'Facebook', url: 'https://facebook.com/orkina', icon: 'M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z' },
    { name: 'YouTube', url: 'https://youtube.com/orkina', icon: 'M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z' },
  ];

  return (
    <footer className="footer" role="contentinfo">
      <div className="container footer__grid">
        {/* Brand & Social */}
        <div className="footer__brand">
          <a
            href="#home"
            className="footer__logo"
            aria-label="Orkina Media Production"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <img
              src="/orkina-logo-white.png"
              alt="Orkina Media Production Logo"
              width="180"
              height="60"
              loading="lazy"
              className="footer__logo-img"
            />
          </a>
          <p className="footer__desc">
            {isRTL 
              ? 'نحول رؤيتكم إلى واقع إبداعي ملموس من خلال أحدث تقنيات الإنتاج الإعلامي.' 
              : 'Transforming your vision into creative reality through state-of-the-art media production.'}
          </p>
          <div className="footer__socials">
            {socialLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={link.name}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d={link.icon} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div className="footer__contact">
          <h4 className="footer__title">{isRTL ? 'اتصل بنا' : 'Contact Us'}</h4>
          <ul className="footer__contact-list">
            <li>
              <a >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>{isRTL ? 'دبي، الإمارات العربية المتحدة' : 'Dubai, UAE'}</span>
              </a>
            </li>
            <li>
              <a href="tel:0567114651">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
                <span>0567114651</span>
              </a>
            </li>
            <li>
              <a href="mailto:info@orkina.com">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>info@orkina.com</span>
              </a>
            </li>
             
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer__links">
          <h4 className="footer__title">{isRTL ? 'روابط سريعة' : 'Quick Links'}</h4>
          <ul>
            <li><a href="#services">{isRTL ? 'خدماتنا' : 'Services'}</a></li>
            <li><a href="#about">{isRTL ? 'من نحن' : 'About Us'}</a></li>
            <li><a href="#contact">{isRTL ? 'اتصل بنا' : 'Contact'}</a></li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <p className="footer__copy">
            &copy; {year} Orkina Media Production. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
